import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
//import { DowngradeInjectable } from '@angular/upgrade/static';
//declare var angular: angular.IAngularStatic;
@Injectable()
export class AssociationRest {

    constructor(private http: HttpClient) {
    }

    fetch(section, refId) {
        return this.http.get(`/api/association/${section}/${refId}`)
            .toPromise()
    }

    save(association: any) {
        return this.http.post('/api/association', association)
            .toPromise()
    }

    delete(section, refId, toSection, toRefId) {
        return this.http.delete(`/api/association/${section}/${refId}/${toSection}/${toRefId}`)
            .toPromise()
    }
}
